import {Grid, TextField, Select, MenuItem, SelectChangeEvent, IconButton, Typography, Box} from "@mui/material";
import React from "react";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import {inputCrawlingParamsInterface} from "../../../../api/definition";

export function CrawlingInputParams(props: any) {
    return (
            <Grid container item spacing={1}>
                {props.input.params &&
                    props.input.params.map((value: inputCrawlingParamsInterface, index: number) =>
                        <Grid container item spacing={1} key={'input_params_'+index} sx={{mb:1}}>
                            <Grid item lg={2} md={2} sm={2} xs={2}>
                                <TextField
                                    required
                                    fullWidth
                                    id={'input_crawling_params_name_'+index}
                                    label='Name'
                                    value={value.name}
                                    onChange={e => props.handleInputParam(e, index)}
                                />
                            </Grid>
                            <Grid item lg={2} md={2} sm={2} xs={2}>
                                <Select
                                    required
                                    fullWidth
                                    id={'input_crawling_params_type_'+index}
                                    value={value.type}
                                    onChange={e => props.handleInputParamType(e, index)}
                                >
                                    <MenuItem value="text">text</MenuItem>
                                    <MenuItem value="numeric">numeric</MenuItem>
                                    <MenuItem value="date">date</MenuItem>
                                    <MenuItem value="list">list</MenuItem>
                                    <MenuItem value="dict">dict</MenuItem>
                                    <MenuItem value="since">since</MenuItem>
                                </Select>
                            </Grid>
                            <Grid item lg={2} md={2} sm={2} xs={2}>
                                <TextField
                                    fullWidth
                                    id={'input_crawling_params_sinceStart_'+index}
                                    label='Since Start'
                                    value={value.sinceStart}
                                    disabled={value.type !== 'since'}
                                    onChange={e => props.handleInputParam(e, index)}
                                />
                            </Grid>
                            <Grid item lg={2} md={2} sm={2} xs={2}>
                                <TextField
                                    fullWidth
                                    id={'input_crawling_params_sinceEnd_'+index}
                                    label='Since End'
                                    value={value.sinceEnd}
                                    disabled={value.type !== 'since'}
                                    onChange={e => props.handleInputParam(e, index)}
                                />
                            </Grid>
                            <Grid item lg={2} md={2} sm={2} xs={2}>
                                <TextField
                                    fullWidth
                                    id={'input_crawling_params_value_'+index}
                                    label='Value'
                                    value={value.value}
                                    onChange={e => props.handleInputParam(e, index)}
                                />
                            </Grid>
                            <Grid item lg={1} md={1} sm={1} xs={1} sx={{
                                    display: 'flex',
                                    justifyContent: 'center'
                                }}
                            >
                                <IconButton
                                    edge='start'
                                    color='inherit'
                                    onClick={() => props.handleInputParamRemove(index)}
                                >
                                    <RemoveCircleOutlineIcon />
                                </IconButton>
                            </Grid>
                        </Grid>
                    )
                }
            </Grid>
    )
}